export default __webpack_public_path__ + "static/media/profile-image-placeholder.c3f94521.png";